import type { IconBaseProps } from "./Icon";

export default function PencilIcon2({ className, color, width, height }: IconBaseProps) {
  return (
    <svg
      className={className}
      style={{ color: color }}
      width={width ?? 24}
      height={height ?? 24}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Pencil</title>
      <path
        d="M5.5 19H6.925L16.7 9.225L15.275 7.8L5.5 17.575V19ZM4.5 21C4.21667 21 3.97933 20.904 3.788 20.712C3.59667 20.52 3.50067 20.2827 3.5 20V17.575C3.5 17.3083 3.55 17.054 3.65 16.812C3.75 16.57 3.89167 16.3577 4.075 16.175L16.7 3.575C16.9 3.39167 17.121 3.25 17.363 3.15C17.605 3.05 17.859 3 18.125 3C18.391 3 18.6493 3.05 18.9 3.15C19.1507 3.25 19.3673 3.4 19.55 3.6L20.925 5C21.125 5.18333 21.2707 5.4 21.362 5.65C21.4533 5.9 21.4993 6.15 21.5 6.4C21.5 6.66667 21.454 6.921 21.362 7.163C21.27 7.405 21.1243 7.62567 20.925 7.825L8.325 20.425C8.14167 20.6083 7.929 20.75 7.687 20.85C7.445 20.95 7.191 21 6.925 21H4.5ZM15.975 8.525L15.275 7.8L16.7 9.225L15.975 8.525Z"
        fill="currentColor"
      />
    </svg>
  );
}
